import React from 'react';
import { Inbox } from 'lucide-react';
import { cn } from '@/lib/utils';
import './primitives.css';

/**
 * A successful load that returned nothing. Say why it is empty and what
 * to do next (e.g. "Add a domain to start monitoring"). Never use this
 * for a failed request: that is <ErrorState>.
 *
 *   variant: 'block' (default) | 'compact'
 */
export default function EmptyState({
  icon: Icon = Inbox,
  title = 'Nothing here yet',
  description,
  action,
  variant = 'block',
  className = '',
}) {
  return (
    <div className={cn('is-state', variant === 'compact' && 'is-state--compact', className)} data-testid="empty-state">
      <span className="is-state-icon" aria-hidden="true">
        <Icon size={18} />
      </span>
      <div className="is-state-title">{title}</div>
      {description && <div className="is-state-text">{description}</div>}
      {action && <div className="is-state-actions">{action}</div>}
    </div>
  );
}
